import { createFetchErrorMessage } from "bf-library";
import axios from "axios";
const { createSlice } = require("@reduxjs/toolkit");

const initialState = { loading: true };
const configSlice = createSlice({
    initialState,
    name: 'app/config',
    reducers: {
        fetch: (state, action) => {
            return { loading: false, ...action.payload };
        }
    }
});

const act = configSlice.actions;
export default configSlice.reducer;

export const fetchConfig = () => {
    return (dispatch) => {
        axios.get('/api/config' )
        .then(res => {
            if (res === undefined) return;
            dispatch(act.fetch(res.data));
        }).catch(err => {
            //이건 없어야 하지만
            const errorData = createFetchErrorMessage(err);
            console.log(errorData);
            // toast.error(errorData.message, {position: "top-center",autoClose:5000});
            setTimeout(() => { window.location = '/'; }, 1000);
        })
    }
}